/*
 * arrest-edit.js
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import { isBeforeArrestDemographicStartDate } from 'utils/misc';
import FormSectionTitle from 'components/menu-drawer/form-section-title';
import InfoRow from 'components/info-row';


const ArrestItemView = (props) => {
  const {
    arrestRecord,
    idx,
    workMode,
  } = props;
  const { t } = useTranslation('deploymentEdit');


  return <>
    <FormSectionTitle 
      sx={{ 
        mb: 1,
        mt: idx === 0 ? 0 : 3 
      }}
      data-testid={`arrest-view-${idx + 1}`}
    >
      {t('arrests.arrest.label', { 'arrestIdx': idx + 1 })}
    </FormSectionTitle>

    {/* Ethnicity */}
    <InfoRow
      title={t('arrests.ethnicity.label')}
      text={arrestRecord.ethnicity.name}
      dataTestId={`info-row-${idx + 1}-race/ethnicity`}
    />

    {/* Sex At Birth */}
    <InfoRow
      title={t('arrests.sexAtBirth.label')}
      text={arrestRecord.sexAtBirth.name}
      dataTestId={`info-row-${idx + 1}-sexAtBirth`}
    />

    {/* Age */}
    <InfoRow
      title={t('arrests.age.label')}
      text={arrestRecord.age === 0 ? 'N/A' : arrestRecord.age}
      dataTestId={`info-row-${idx + 1}-age`}
    />

    {/* Was Subject Bitten */}
    {workMode !== Types.WorkMode.DETECTION &&
      <InfoRow
        title={t('arrests.wasSubjectBitten.label')}
        text={arrestRecord.wasSubjectBitten ? t('arrests.wasSubjectBitten.affirmativeText') : t('arrests.wasSubjectBitten.negativeText')}
        dataTestId={`info-row-${idx + 1}-wasSubjectBitten`}
      />
    }
  </>
};


export default function ArrestsView(props) {
  const {
    deployment,
    record,
  } = props;
  const isRecordBeforeArrestDemographic = isBeforeArrestDemographicStartDate(deployment.date, deployment.dateCreated);
  
  if (!record || record.arrests.length === 0 || isRecordBeforeArrestDemographic) {
    return null;
  }

  return (
    <>
      {record.arrests.map((arrestRecord, idx) => <ArrestItemView
        key={idx}
        {...props}
        arrestRecord={arrestRecord}
        idx={idx}
      />)}
    </>
  );
}